module.exports = __webpack_public_path__ + "static/media/otherCopy.40f606e2.svg";